import ManageUserDashboards from './ManageUserDashboards';

export default ManageUserDashboards;
